import { BaseDto } from "./base.dto"

import { PagingDto } from "./paging.dto"
import { ProductDto } from "./product.dto"

export class FindFlashSaleDto extends PagingDto {
  status: string
}

export class FlashSaleDto extends BaseDto {
  name: string
  nameKh: string
  status: string
  isJoined: boolean
  minDiscount: number
  discountType: string
  startTime: Date
  endTime: Date
  discount: number

  static create() {
    return new FlashSaleDto()
  }
}

export class FindFlashSaleProductDto extends PagingDto {
  searchText?: string
}

export class FlashSaleItemDto extends BaseDto {
  productId: string
  product: ProductDto
  status: string
  discount: number
  discountType: string
}

export class CreateFlashSaleItemDto {
  discount: number
  isAll: boolean
  productIds: string
}